import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Types, refreshTokenError, setRefreshToken, IPayload } from './actions';
import { generateAccessToken } from '~/helpers/api/login';
import { setAxiosHeader } from '~/helpers/setAxiosHeader';
import { getIssuer } from '~/helpers/getIssuer';
import { sensedia } from '~/config/constants';
import { getEnvFromUrl } from '~/helpers/getEnv';

interface IToken {
  refresh_token: string;
}

const issuer = getIssuer();
const { isProd } = getEnvFromUrl();
const envFromUrl = isProd ? 'PROD' : 'NON_PROD';

// @ts-ignore
const { clientId, clientSecret } = sensedia[issuer][envFromUrl];
const strBase64 = btoa(`${clientId}:${clientSecret}`);

export function* refreshToken({ payload }: IPayload) {
  try {
    // Headers needed in generateAccessToken
    setAxiosHeader([
      {
        name: 'client_id',
        value: clientId,
      },
      {
        name: 'Authorization',
        value: `Basic ${strBase64}`,
      },
    ]);

    const response: IToken = yield call(generateAccessToken, payload);
    yield put(setRefreshToken(response?.refresh_token));

    const accessToken: string = sessionStorage.getItem('token') || '';

    // Header needed in bffs
    setAxiosHeader([
      {
        name: 'Authorization',
        value: accessToken,
      },
    ]);
  } catch (error) {
    yield put(refreshTokenError(error));
  }
}

// @ts-ignore
export default all([takeLatest(Types.REQUEST, refreshToken)]);
